class CouponStatusType {
  None() {
    return 0;
  }
  Active() {
    return 1;
  }
  Expired() {
    return 2;
  }
}
export default new CouponStatusType();
